// extracted by mini-css-extract-plugin
module.exports = {"article":"offer-section-module--article--2OFDd","reverse":"offer-section-module--reverse--1A2YT"};